import { createAction } from "redux-actions";
import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

// Actions
export const SHOW_MODAL = "DOMAIN@UI/MODAL::SHOW";
export const HIDE_MODAL = "DOMAIN@UI/MODAL::HIDE";
export const SWITCH_MODAL = "DOMAIN@UI/MODAL::SWITCH";
export const MINIMISE_MODAL = "DOMAIN@UI/MODAL::MINIMISE";
export const MAXIMISE_MODAL = "DOMAIN@UI/MODAL::MAXIMISE";
export const SET_LAST_X = "DOMAIN@UI/MODAL::SET_LAST_X";
export const SET_LAST_Y = "DOMAIN@UI/MODAL::SET_LAST_Y";
export const SET_LAST_WIDTH = "DOMAIN@UI/MODAL::SET_LAST_WIDTH";
export const SET_LAST_HEIGHT = "DOMAIN@UI/MODAL::SET_LAST_HEIGHT";

// Action Creators
export const showModal = createAction(SHOW_MODAL, (kind, props) => ({
  kind,
  props
}));
export const hideModal = createAction(HIDE_MODAL, () => null);
export const switchModal = createAction(SWITCH_MODAL);
export const minimiseModal = createAction(MINIMISE_MODAL, () => null);
export const maximiseModal = createAction(MAXIMISE_MODAL, () => null);
export const setLastX = createAction(SET_LAST_X);
export const setLastY = createAction(SET_LAST_Y);
export const setLastWidth = createAction(SET_LAST_WIDTH);
export const setLastHeight = createAction(SET_LAST_HEIGHT);

// Selectors
const getModal = path(["domain", "ui", "modal"]);
export const selectModal = createSelector(getModal, identity);

export const selectKind = createSelector(getModal, prop("kind"));

export const selectProps = createSelector(getModal, prop("props"));

export const selectIsMinimised = createSelector(getModal, prop("isMinimised"));

export const selectIsMaximised = createSelector(getModal, prop("isMaximised"));

export const selectLastX = createSelector(getModal, prop("lastX"));
export const selectLastY = createSelector(getModal, prop("lastY"));
export const selectLastWidth = createSelector(getModal, prop("lastWidth"));
export const selectLastHeight = createSelector(getModal, prop("lastHeight"));

// Initial State
const initialState = () => ({
  kind: null,
  props: {},
  isMinimised: false,
  isMaximised: true,
  lastX: null,
  lastY: null,
  lastWidth: null,
  lastHeight: null
});

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        ...action.payload,
        isMinimised: false,
        isMaximised: true
      };

    case HIDE_MODAL:
      return {
        ...initialState(),
        lastX: state.lastX,
        lastY: state.lastY,
        lastWidth: state.lastWidth,
        lastHeight: state.lastHeight
      };

    case SWITCH_MODAL:
      return { ...state, kind: action.payload };

    case MINIMISE_MODAL:
      return { ...state, isMinimised: true, isMaximised: false };

    case MAXIMISE_MODAL:
      return { ...state, isMinimised: false, isMaximised: true };

    case SET_LAST_X:
      return { ...state, lastX: action.payload };

    case SET_LAST_Y:
      return { ...state, lastY: action.payload };

    case SET_LAST_WIDTH:
      return { ...state, lastWidth: action.payload };

    case SET_LAST_HEIGHT:
      return { ...state, lastHeight: action.payload };

    default:
      return state;
  }
}
